// 数字藏品管理路由
export default {
    path: 'nftManage',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '数字藏品管理'},
    children:[{
        path: 'contract',
        component: () => import('@/components/RouterView'),
        redirect: '/nftManage/contract/list',
        meta: { title: '合约管理'},
        children: [
            {
                path: 'list',
                component: () => import('@/views/nftManage/contract/list'),
                meta: {title: '合约列表'}
            },
            {
                path: 'edit/:id',
                component: () => import('@/views/nftManage/contract/edit'),
                meta: {title: '编辑合约'},
                props: true
            },
            {
                path: 'add',
                component: () => import('@/views/nftManage/contract/edit'),
                meta: {title: '创建合约'},
            }
        ]
    },{
        path: 'nft',
        component: () => import('@/components/RouterView'),
        redirect: '/nftManage/nft/list',
        meta: { title: 'NFT管理'},
        children: [
            {
                path: 'list',
                component: () => import('@/views/nftManage/nft/list'),
                meta: {title: 'NFT列表'}
            }
        ]
    },{
        path: 'present',
        component: () => import('@/components/RouterView'),
        redirect: '/nftManage/present/list',
        meta: { title: '转赠记录'},
        children: [
            {
                path: 'list',
                component: () => import('@/views/nftManage/present/list'),
                meta: {title: '转赠记录'}
            }
        ]
    },{
        path: 'exchange',
        component: () => import('@/components/RouterView'),
        redirect: '/nftManage/exchange/list',
        meta: { title: '兑换记录'},
        children: [
            {
                path: 'list',
                component: () => import('@/views/nftManage/exchange/list'),
                meta: {title: '兑换记录'}
            }
        ]
    }]
};
